export default {
  // Số tiền
  CurrencyDecimalDigits: 'CurrencyDecimalDigits',
  // Đơn giá
  CurrencyUnitPriceDigits: 'CurrencyUnitPriceDigits',
  // Ngoại tệ
  AmountOCDecimalDigits: 'AmountOCDecimalDigits',
  // Tỷ giá
  ExchangeRateDecimalDigits: 'ExchangeRateDecimalDigits',
  // Hệ số, tỉ lệ
  PercentDecimalDigits: 'PercentDecimalDigits',
  // Số công
  WorkDecimalDigits: 'WorkDecimalDigits',
  // Số lượng
  NumberDecimalDigits: 'NumberDecimalDigits',

  // phân quyền kế toán theo khu vực
  RegionalAccounting : 'RegionalAccounting',
};
